import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store/index'
import { getToken } from '@/utils/auth'

// create an axios instance
const service = axios.create({
  // baseURL: 'http://clock.cqprosper.com/v1',
  baseURL: 'http://clock.xwyy.com/v1', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['token'] = getToken()
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(

  response => {
    const res = response.data
    if (res.code !== 200) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 3 * 1000
      })
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    const errorData = error.response // for debug
    if (errorData.status === 401) {
      Message({
        message: 'token失效，请重新登录',
        type: 'error',
        duration: 3 * 1000
      })
      setTimeout(() => {
        store.dispatch('user/resetToken').then(() => {
          location.reload()
        })
      }, 3000)
    } else {
      Message({
        message: errorData.data.message,
        type: 'error',
        duration: 3 * 1000
      })
    }
    return Promise.reject(error.message || 'Error')
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js